/**
 * organizationBuilder — sub-container do slice de organização.
 *
 * Agrupa CRUD de Polo (campus por tenant), Sector (setores) e
 * Mantenedora (entidade global SuperAdmin). IES (read-only) continua
 * montado direto no container.
 *
 * @since sprint Organization (FE espelhando organization-api do BE)
 */
import type { $Fetch } from 'ofetch';

import { HttpPoloGateway } from '@/infrastructure/http/HttpPoloGateway';
import { HttpSectorGateway } from '@/infrastructure/http/HttpSectorGateway';
import { HttpMantenedoraGateway } from '@/infrastructure/http/HttpMantenedoraGateway';
import { HttpTenantOnboardingGateway } from '@/infrastructure/http/HttpTenantOnboardingGateway';

import {
  ListPolos, GetPolo, CreatePolo, UpdatePolo, DeactivatePolo,
} from '@/application/usecase/PoloUseCaseImpl';
import { OnboardTenant } from '@/application/usecase/TenantOnboardingUseCaseImpl';
import {
  ListSectors, GetSector, CreateSector, UpdateSector, DeactivateSector,
} from '@/application/usecase/SectorUseCaseImpl';
import {
  ListMantenedoras, GetMantenedora, CreateMantenedora, UpdateMantenedora, DeactivateMantenedora,
} from '@/application/usecase/MantenedoraUseCaseImpl';

export function buildOrganizationSlice(httpClient: $Fetch) {
  const poloGateway = new HttpPoloGateway(httpClient);
  const sectorGateway = new HttpSectorGateway(httpClient);
  const mantenedoraGateway = new HttpMantenedoraGateway(httpClient);
  const tenantOnboardingGateway = new HttpTenantOnboardingGateway(httpClient);

  const useCases = {
    listPolos: new ListPolos(poloGateway),
    getPolo: new GetPolo(poloGateway),
    createPolo: new CreatePolo(poloGateway),
    updatePolo: new UpdatePolo(poloGateway),
    deactivatePolo: new DeactivatePolo(poloGateway),
    listSectors: new ListSectors(sectorGateway),
    getSector: new GetSector(sectorGateway),
    createSector: new CreateSector(sectorGateway),
    updateSector: new UpdateSector(sectorGateway),
    deactivateSector: new DeactivateSector(sectorGateway),
    listMantenedoras: new ListMantenedoras(mantenedoraGateway),
    getMantenedora: new GetMantenedora(mantenedoraGateway),
    createMantenedora: new CreateMantenedora(mantenedoraGateway),
    updateMantenedora: new UpdateMantenedora(mantenedoraGateway),
    deactivateMantenedora: new DeactivateMantenedora(mantenedoraGateway),
    onboardTenant: new OnboardTenant(tenantOnboardingGateway),
  };

  return { useCases };
}
